import type { FC } from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { SvgIconProps } from '@mui/material/SvgIcon/SvgIcon';

export const TradeIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 18 18">
    <path d="M15.75 6.75L12.75 3.75V6H7.5V7.5H12.75V9.75L15.75 6.75ZM5.25 8.25L2.25 11.25L5.25 14.25V12H10.5V10.5H5.25V8.25Z" />
  </SvgIcon>
);
